import {Button} from "@zendeskgarden/react-buttons";
import {ReactElement} from "react";

import * as css from "./styles/selectionBar.module.scss";
import {ManualProperty} from "../logic/types";
import {RevenueModelType} from "../../../../__generated__/generated_types";

export interface ISelectionBar {
    selected: ManualProperty[];
    onEdit: () => void;
    onFetchTemplates: () => void;
    onUploadFiles?: () => void;
    onSetRevenueModel?: () => void;
    onSetRentSubsidyEnabled?: (val: boolean) => void;
    name: string;
    namePlural: string;
    isManual: boolean;
    enableBulk?: boolean;
}

export default function SelectionBar(props: ISelectionBar): ReactElement {
    return (
        <div className={`${css.userSelectionBar} ${props.selected.length ? css.userSelectionBarVisible : ''}`}>
            <div className={css.userSelectionBarCount}><span>{props.selected.length}</span></div>
            <h4>{props.selected.length == 1 ? props.name : props.namePlural} selected</h4>

            {/* until bulk editing is ready, hide the edit button for bulk operations */}
            <Button className={`${css.userSelectionButton} ${props.selected.length > 1 && !props.enableBulk ? css.userSelectionButtonHidden : ''}`} onClick={props.onEdit} disabled={props.selected.length > 1 && !props.enableBulk}>
                {props.selected.length == 1 ? `Edit ${props.name}` : "Bulk Edit"}
            </Button>

            {props.onSetRevenueModel &&
                <Button className={css.userSelectionButton} onClick={props.onSetRevenueModel}>
                    Set Revenue Model
                </Button>
            }

            {props.selected.some(p => p.revenueModel === RevenueModelType.Original || p.revenueModel === RevenueModelType.LeaseUp) && props.onSetRentSubsidyEnabled &&
                <Button className={css.userSelectionButton} onClick={() => props.onSetRentSubsidyEnabled?.(true)}>Enable Rent Subsidy</Button>
            }

            {props.selected.some(p => p.revenueModel === RevenueModelType.Original || p.revenueModel === RevenueModelType.LeaseUp) && props.onSetRentSubsidyEnabled &&
                <Button className={css.userSelectionButton} onClick={() => props.onSetRentSubsidyEnabled?.(false)}>Disable Rent Subsidy</Button>
            }

            {props.selected.length === 1 && props.isManual &&
                <Button className={css.userSelectionButton} onClick={props.onFetchTemplates}>CSV Templates</Button>
            }

            {props.selected.length === 1 && props.onUploadFiles && props.isManual &&
                <Button className={css.userSelectionButton} onClick={props.onUploadFiles}>Upload Files</Button>
            }
        </div>
    );
}